import { Block, Flex, IconButton, Typography } from '@aloft/toolkit-sui';

import { useModuleContext } from '../../modules/shared/moduleContext/useModuleContext.ts';

export const MainHeaderTitle = ({
  title,
  shouldShowHeaderNavigation,
  showBackButton,
  onBackButtonClick,
}: {
  title: string;
  shouldShowHeaderNavigation: boolean;
  showBackButton: boolean;
  onBackButtonClick?: () => void;
}) => {
  const {
    navigation: { useNavigate },
  } = useModuleContext();

  const navigate = useNavigate();

  if (shouldShowHeaderNavigation) {
    return (
      <div className="main-header-title-with-nav" title={title}>
        <Typography variant="h2" title={title} truncate>
          {title}
        </Typography>
      </div>
    );
  }

  return (
    <Flex flexGrow={1} gap={1} alignItems="center">
      {showBackButton && (
        <Block flexShrink={1}>
          <IconButton
            id="back-btn"
            ariaLabel="back"
            icon="arrow-left"
            onClick={() => {
              if (onBackButtonClick) {
                onBackButtonClick();
              } else {
                navigate(-1);
              }
            }}
            variant="tertiary"
            size="md"
            __dangerDoNotUseSx={{
              svg: { height: '22px', width: '22px' },
            }}
          />
        </Block>
      )}
      <Typography variant="h2">{title}</Typography>
    </Flex>
  );
};
